let axios = require('axios');

let axiosConfig = {
  baseURL: '/api/'
};

axios = axios.create(axiosConfig)

module.exports = {
    init: function () {
        //Articles may or may not render as the contact form.
        //Contact form may or may not be because of Articles.

        function initializeArticle(article, callback) {
            let articleId = article.dataset.articleId;
            let culture = article.dataset.cultureCode;

            axios(
                {
                    url: culture + "/gatedarticle/" + articleId,
                    headers: { 'Content-Type': 'application/json' },
                    method: "get"
                })
                .then(function (response) {
                    // Success
                    article.id = "article-body";
                    article.dataset.articleid = "";
                    article.innerHTML = response.data;
                    callback();
                })
                .catch(function (error) {
                    if (error.response) {
                        let data = error.response.data;

                        console.log(data);
                        alert("An error has occurred, please try again.");
                    }
                });
        }

        function initializeContactForm(form) {
            let formElement = form.querySelector("form");
            let allFields = Array.from(form.querySelectorAll("input"));

            let divState = formElement.querySelector("div#divState");
            let drpCountry = formElement.querySelector("select#countryId");
            let drpState = formElement.querySelector("select#stateId");

            CheckStateState(drpCountry, drpState, divState);

            drpCountry.addEventListener('change', function () {
                CheckStateState(drpCountry, drpState, divState);
            });

            formElement.addEventListener('submit', function () {
                CheckStateState(drpCountry, drpState, divState);
            });

            function CheckStateState(drpCountry, drpState, divState)
            {
                var selectedCountry = drpCountry.value;
                if (selectedCountry == 271) //US 
                {
                    divState.style.display = 'block';
                    drpState.setAttribute('required', 'required');
                }
                else
                {
                    divState.style.display = 'none';
                    drpState.removeAttribute('required');
                    drpState.value = '';
                }
            }

            formElement.onsubmit = function (evt) {
                form.querySelector(".contact-form-submit-button").style.display = "none";
                evt.preventDefault();
                var dataObject = {};

                let allControls = Array.from(form.querySelectorAll(".form-control"));

                allControls.forEach((control) => {
                    dataObject[control.name] = control.value;
                });

                var json = JSON.stringify(dataObject);

                var url = formElement.dataset.cultureCode + "/" + formElement.dataset.api

                //console.log(json);

                axios(
                    {
                        url: url,
                        data: json,
                        headers: { 'Content-Type': 'application/json' },
                        method: "post"
                    })
                    .then(function (response) {
                        // Success
                        form.querySelector(".contact-form-main").style.display = "none";
                        form.querySelector(".contact-form-success").style.display = "block";
                        form.querySelector(".contact-form-success-message").innerHTML = response.data.message;
                        form.querySelector(".contact-form-success").scrollIntoView();
                        if (formElement.dataset.refreshOnSubmit === 'true') {
                            setTimeout(function () {
                                // reload the page
                                document.location.reload();
                            }, 0);
                        }
                    })
                    .catch(function (error) {
                        // Assumes that the server returns a non-400 error code

                        allFields.forEach(field => {
                            field.classList.remove("error");
                            field.removeAttribute("aria-describedby");

                            let errorElement = form.querySelector(".errors-" + field.name);
                            if (errorElement)
                                errorElement.innerHTML = "";
                        });

                        // re-show submit button
                        form.querySelector(".contact-form-submit-button").style.display = "block";

                        if (error.response) {
                            let data = error.response.data;

                            if (data.status == "validation") {
                                if (data.message) {
                                    // Show error messages

                                    for (var fieldName in data.message) {
                                        let errorElement = form.querySelector(".errors-" + fieldName);

                                        if (errorElement) {
                                            let field = form.querySelector("input[name='" + fieldName + "']");
                                            field.setAttribute("aria-describedby", "errors-" + fieldName);

                                            errorElement.innerHTML = "<li>" + data.message[fieldName].join("</li><li>") + "</li>";

                                            field.classList.add("error");
                                        }

                                    }
                                }
                            } else {
                                alert("An error has occurred, please try again.");
                            }

                            // Request made and server responded
                            //console.log(error.response.data);
                            //console.log(error.response.status);
                            //console.log(error.response.headers);
                        }
                    });
            }
        }

        function initializeAnyContactForms() {
            var forms = document.querySelectorAll(".contact-form-wrapper:not(.initialized)");
            Array.from(forms).forEach(form => {
                initializeContactForm(form);
                form.classList.add("initialized");
            });
        }

        var article = document.getElementById("article-body-placeholder");
        if (article == null)
            initializeAnyContactForms();
        else
            initializeArticle(article, initializeAnyContactForms);
    }
}